module.exports = __webpack_public_path__ + "img/apexlogo.badc059d.png";